
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppCommonModule } from '../common.module';
import { ContractsComponent } from '../components/partner-home/offer/contracts/contracts.component';
import { DashboardViewComponent } from '../components/views/dashboard/view-dashboard.component';

@Component({
  selector: 'app-contracts-page',
  templateUrl: './contracts.page.html',
  styleUrls: ['./contracts.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AppCommonModule,
    DashboardViewComponent,
    ContractsComponent,
  ],
})
export class ContractsPage {

}
